@if (isFileNode) {
  <ng-container>
    <div class="d-flex align-item-center ms-auto ms-md-0">
      <div class="version-dropdown d-block" ngbDropdown container="body" dropdownClass="media-player-version-dropdown">
        <button
          ngbDropdownToggle
          [disabled]="isBusy || shouldDisableInteractiveElements"
          (click)="$event.stopPropagation()"
          class="btn d-flex align-item-center justify-content-between dropdown-toggle">
          <span class="version me-2">{{ 'V' + subSectionState?.activeVersion?.versionNumber }}</span>
          <span class="d-flex align-items-center justify-content-center">
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </span>
        </button>
        <div ngbDropdownMenu class="p-1 dropdown-menu">
          <button
            *ngFor="let version of subSectionState?.activeOption?.simpleVersions"
            class="d-flex align-items-center btn dropdown-item version-selector-dropdown"
            [disabled]="isBusy"
            (click)="switchVersion(version.versionNumber)">
            <span class="version">{{ 'V' + version.versionNumber }}</span>
          </button>
          @if (hasEditPermission) {
            <button
              class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-manage-versions"
              [disabled]="isBusy"
              (click)="showManageVersions()">
              <span class="text-uppercase">{{ translate('versioning_edit_manageVersions') }}</span>
            </button>
            <button
              class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-add-version"
              [disabled]="isBusy"
              (click)="createNewVersion()">
              <span class="d-flex align-items-center justify-content-center icon-wrapper me-2">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </span>
              <span class="text-uppercase">{{ translate('versioning_edit_createNewVersion') }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  </ng-container>
}
